<template>
    <div class="w-full h-full flex flex-col">
        <h1 class="text-brand text-lg font-extrabold mb-2 border-gray-200 border-b h-8 overflow-hidden">
            <span class="ml-4 whitespace-nowrap"><i class="far fa-calendar-check mr-4"></i>Payment Cert Uncertified</span>
        </h1>
        <main class="overflow-hidden flex-1 place-content-center">
            <div v-if="package" class="flex flex-col text-gray-500">
                <div class="w-full text-center text-3xl" v-text="'£'+money(package.accounts.payment_cert_uncertified)"></div>
            </div>
        </main>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        dashboardData: Object,
        dashboardProps: Object,
    },
    data() {
        return {
            package: null,
        }
    },
    computed: {},
    methods: {
        money: function (val) {
            return parseFloat(val).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        },
    },
    mounted() {
        this.package = this.dashboardProps.legacyPackage
    }
}

</script>